// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLvcCapture_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 0H7V4H9V5H11V12H13V5H15V4H17V0H15V2H9V0ZM6.86608 7.30383 5.13403 8.30383 7.63403 12.634 9.36608 11.634 6.86608 7.30383ZM17.134 7.30383 18.8661 8.30383 16.3661 12.634 14.634 11.634 17.134 7.30383Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.23934 21.0896C1.47725 21.5913 0.707632 22.2262 0 23.012V20.2566C1.4468 19.0734 2.97099 18.324 4.23806 17.918C4.68782 16.9047 5.59045 15.8047 6.7226 14.9219C8.08716 13.8579 9.92252 13 12 13C14.0775 13 15.9128 13.8579 17.2774 14.9219C18.4095 15.8047 19.3122 16.9047 19.7619 17.918C21.029 18.324 22.5532 19.0734 24 20.2566V23.012C23.2924 22.2262 22.5228 21.5913 21.7607 21.0896L21.7523 21.0923C21.5066 21.1716 21.1554 21.2836 20.7414 21.3589C19.8892 21.5138 18.786 21.511 17.5528 20.8944C17.2393 20.7377 16.9446 20.5854 16.663 20.4399C15.059 19.6111 13.8764 19 12 19C10.1236 19 8.94097 19.6111 7.33696 20.4399C7.05538 20.5854 6.76081 20.7376 6.44721 20.8944C5.214 21.511 4.11075 21.5138 3.25862 21.3589C2.84456 21.2836 2.49343 21.1716 2.24768 21.0923L2.23934 21.0896ZM6.00676 18.8742C6.12442 18.8134 6.24189 18.7522 6.35944 18.6909C7.97353 17.8497 9.60396 17 12 17C14.396 17 16.0265 17.8497 17.6406 18.6909C17.7581 18.7522 17.8756 18.8134 17.9932 18.8742C17.7654 18.2595 17.1021 17.3213 16.0476 16.4991C14.9372 15.6333 13.5225 15 12 15C10.4775 15 9.06285 15.6333 7.9524 16.4991C6.89795 17.3213 6.2346 18.2595 6.00676 18.8742Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLvcCapture is a generated icon component.
 */
let IconMedLvcCapture = IconMedLvcCapture_1 = class IconMedLvcCapture extends IconBaseElement {
    render() {
        return html `${IconMedLvcCapture_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLvcCapture.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLvcCapture = IconMedLvcCapture_1 = __decorate([
    customElement('zui-icon-med-lvc-capture')
], IconMedLvcCapture);
export { IconMedLvcCapture };
